import React from 'react'

export default ({ className, title }) => (
    <svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
        <title>{title}</title>
        <g id="7-9" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g id="RM---answer-autogen-question" transform="translate(-383.000000, -1199.000000)" stroke="#56565A">
                <g id="list-bullets" transform="translate(383.000000, 1199.000000)">
                    <circle id="Oval" fill="#56565A" cx="2.625" cy="2.62325" r="1.96875"></circle>
                    <circle id="Oval" fill="#56565A" cx="2.625" cy="10.49825" r="1.96875"></circle>
                    <circle id="Oval" fill="#56565A" cx="2.625" cy="18.37325" r="1.96875"></circle>
                    <path d="M7.21875,3.2795 L20.34375,3.2795" id="Path"></path>
                    <path d="M7.21875,11.1545 L20.34375,11.1545" id="Path"></path>
                    <path d="M7.21875,19.0295 L20.34375,19.0295" id="Path"></path>
                </g>
            </g>
        </g>
    </svg>
)
